<template>
  <div class="animated revealUp" style="zoom: 0.9">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("paymentmode") }}
      </div>
      <router-link class="btn-blue" to="payment-modes">{{ $tc("paymentmode") }} {{ $tc("list", 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div v-for="(item, index) in PaymentModes" :key="index" v-if="showField(item)"
          :class="item.hasOwnProperty('class') ? item.class : ''" class="align-self-center mb-3">
          <div v-if="!['pm_is_active', 'pm_is_refund_available'].includes(item.fieldname)">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input @focus="onFocusHandler" :type="item.type" :name="item.fieldname" :id="item.fieldname"
                  v-validate="item.validation" v-model="item.fieldvalue" placeholder="."
                  v-b-tooltip.hover.top="$t(item.tooltip)" />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'pm_is_refund_available'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">Avail Refund</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox type="checkbox" class="j-checkbox" v-model="item.fieldvalue" />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
          <div v-if="item.fieldname === 'pm_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox type="checkbox" class="j-checkbox" v-model="item.fieldvalue" />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-xl-3">
          <div class="dropdown-curve-container">
            <label :class="selectedCinemas.length ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("cinema", 1)
              }}</label>
            <multiselect v-model="selectedCinemas" :options="cinemas" placeholder="" label="cine_name"
              track-by="cine_id" :searchable="true" :multiple="true"></multiselect>
          </div>
        </div>

        <!-- <div class="col-2 align-self-center mb-3" >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input placeholder="." v-model="selected_color_code" type="color"
                      name="color_code" id="color_code" />
                    <label>{{ "Color Code" }}</label>
                  </div>
                </div>
                <p class="error_message">
                </p>
              </div> -->
              <div class="col-3 align-self-center mb-3" >
                <div class="w-full d-flex align-items-center">
                  <div >
                    <input placeholder="." v-model="selected_color_code" type="color"
                    name="color_code" id="color_code" />
                  </div>
                  <div class="ml-2 mt-2">
                  
                    <label>{{ "Color Code" }}</label>
                  </div>
                </div>
                <p class="error_message">
                </p>
              </div>
        <div class="col-12">
          <div class="row">
            <b-form-checkbox v-for="(source, sourceIndex) in bookingSources" :key="sourceIndex"
              v-model="selectedSources" :value="source" class="j-checkbox"
              @change="checkuncheckBookingSource($event, sourceIndex)">
              <div class="mr-2">{{ source.bs_source }}</div>
            </b-form-checkbox>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onUpdateHandler" class="btn-blue">
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="payment-modes">{{ $t("cancel") }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PaymentModes from "@/helper/formJSONMaster/PaymentModes";
import _ from "lodash";

export default {
  data() {
    return {
      selected_color_code:'',
      pm_payment_mode: "",
      PaymentModes: PaymentModes.ms_payment_modes,
      cinemas: [],
      Methods: PaymentModes.Methods,
      submitted: false,
      mapping_list: [],
      bookingSources: [],
      selectedCinemas: [],
      sourceOptions: [],
      selectedSources: [],
      selected: [],
      unselected: [],
      payment_mode_id: null,
    };
  },
  computed: {
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
    },
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    this.payment_mode_id = id;
    this.getCinemas().then(() => {
      if (id) {
        this.getEditList(id);
        this.getBsPaymentMap(id);
      } else {
        this.$router.go(-1);
      }
    });
  },
  mounted() { },
  methods: {
    getCinemas: async function () {
      this.cinemas = [];
      try {
        let payload = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        const response = await MasterService.GetActiveList(payload);
        const { data } = response;
        if (data.status && data.Records.length) {
          this.cinemas = [...data.Records];
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error, "from cinemas");
      }
    },
    showField(item) {
      let status = true; //show

      if (item.fieldname == 'pm_id') {
        status = false
      } else if (!this.showErpColumns && item.fieldkey == 'erp_field') {
        status = false
      } else {
        status = true
      }
      return status;
    },
    checkuncheckBookingSource(e, index) {
      let event = _.cloneDeep(e);
      console.log("\nevent :>> ", event);

      let selected = event;
      let unselected = _.cloneDeep(
        this.bookingSources.filter(
          (x) => !selected.map((s) => s.bs_id).includes(x.bs_id)
        )
      );
      let ml = _.cloneDeep(this.mapping_list);

      console.log({ ml, selected, unselected });

      let ss = [];
      selected.forEach((s) => {
        let sx = ml.filter((m) => {
          return (
            m.booking_source_id == s.booking_source_id &&
            m.payment_mode_id == this.payment_mode_id
          );
        });

        ss = ss.concat(sx);
        // console.log({ sx })
      });
      this.selected = ss;

      // push missing
      if (this.selected.length < selected.length) {
        selected.forEach((s) => {
          let ifNotExist =
            this.selected.filter(
              (x) => x.booking_source_id == s.booking_source_id
            ).length === 0;

          if (ifNotExist) {
            this.selected.push({
              booking_source_id: s.bs_id,
              mapping_is_active: "Y",
            });
          }
        });
      }

      let us = [];
      unselected.forEach((s) => {
        let ux = ml.filter((m) => {
          return (
            m.booking_source_id == s.booking_source_id &&
            m.payment_mode_id == this.payment_mode_id
          );
        });

        us = us.concat(ux);
        // console.log({ ux })
      });
      this.unselected = us;

      console.log("this.selected :>> ", {
        "this.selected": this.selected,
        selected,
        ss,
      });
      console.log("this.unselected :>> ", {
        "this.unselected": this.unselected,
        unselected,
        us,
      });
      this.$forceUpdate();
    },
    getBsPaymentMap(id) {
      let body = {
        tableName: "booking_source_payment_mapping",
        payment_mode_id: id,
      };
      MasterService.GetActiveList(body).then((response) => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            let flat = _.cloneDeep(data.Records);

            let group = _(flat)
              .groupBy("booking_source_id")
              .sortBy((group) => flat.indexOf(group[0]))
              .value()
              .map((row) => {
                // console.log({row})
                return row.sort((a, b) => {
                  // console.log(b.bspm_id, a.bspm_id)
                  return b.bspm_id - a.bspm_id;
                });
              });

            this.mapping_list = [];
            group.forEach((g) => {
              this.mapping_list.push(g[0]);
            });

            console.log({
              group,
              mapping_list: this.mapping_list,
            });

            // this.mapping_list = data.Records;
            this.mapping_list.map((x) => {
              if (x.mapping_is_active == "Y") {
                this.selected.push(x);
              } else {
                this.unselected.push(x);
              }
            });
            console.log("this.mapping_list :>> ", this.mapping_list);
            this.getBookingSources();
          } else {
            this.getBookingSources();
          }
        } else this.$toasted.show(data.message || "Opps! Something went wrong");
      });
    },
    getBookingSources() {
      let body = {
        tableName: "ms_booking_sources",
        bs_is_active: "Y",
      };
      MasterService.GetActiveList(body).then((response) => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            this.bookingSources = data.Records;
            console.log("this.bookingSources :>> ", this.bookingSources);
            this.bookingSources.map((x) => {
              x.booking_source_id = x.bs_id;

              this.mapping_list.map((y) => {
                // console.log("x.bs_id :>> ", x.bs_id);
                // console.log("y.booking_source_id  :>> ", y.booking_source_id);
                // console.log("y.mapping_is_active :>> ", y.mapping_is_active);
                if (
                  x.bs_id == y.booking_source_id &&
                  y.mapping_is_active == "Y"
                ) {
                  this.selectedSources.push(x);
                }
              });
            });
            console.log("this.selectedSources :>> ", this.selectedSources);
          }
        } else this.$toasted.show(data.message || "Opps! Something went wrong");
      });
    },
    resetHandler: function () {
      this.PaymentModes.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getEditList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :");
            let obj = data.details[0];
            this.selectedCinemas = []

            if (this.cinemas && obj.available_cinemas) {
              let cinemasArr = obj.available_cinemas.split(",")

              cinemasArr.forEach(cinemasObj => {
                let cinemaIndex = this.cinemas.findIndex(cinemaData => {
                  return cinemaData.cine_id == cinemasObj
                })

                if (cinemaIndex >= 0) {
                  this.selectedCinemas.push(this.cinemas[cinemaIndex])
                }
              })
            }

            this.PaymentModes.map((x) => {
              if (["pm_is_active", "pm_is_refund_available"].includes(x.fieldname)) {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
            console.log("Object=>",obj)
            this.selected_color_code=obj.color_code
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onUpdateHandler: function () {
      // let body = this.getRequestBody("PUT", this.PaymentModes, {
      //   ...this.Methods,
      //   params: { id: this.$route.query.id }
      // });
      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       console.log("here :", data);
      //       this.$router.push({
      //         path: "/master/payment-modes"
      //       });
      //     } else {
      //       console.log("show error :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     console.log("show error :", error);
      //   });
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          console.log("valid :", valid);
       console.log("PaymentModes=>",this.PaymentModes);
       console.log("this.Methods=>",this.Methods)
          let body = this.getRequestBody("PUT", this.PaymentModes, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });
          console.log("body :", body);
          let isRefundAvailable = PaymentModes.ms_payment_modes.find(paymentsObj => {
            return paymentsObj.fieldname == "pm_is_refund_available"
          })
          if(this.selected_color_code){
            body.payload.color_code=this.selected_color_code
          }
          MasterService.GlobalRequest(body)
            .then((response) => {
              const { data } = response;

              if (data.status) {
                let payload = {
                  selected: this.selected,
                  unselected: this.unselected,
                  payment_mode_id: this.payment_mode_id,
                  pm_is_refund_available: isRefundAvailable.fieldvalue ? "Y" : "N",
                  color_code:this.selected_color_code,
                  selectedCinemas: this.selectedCinemas.length ? this.selectedCinemas.map(cinemasObj => {
                    return cinemasObj.cine_id
                  }).toString() : ""
                };
                MasterService.EditBsPaymentMapping(payload).then((response) => {
                  const { data } = response;
                  if (data.status) {
                    this.$router.push({
                      path: "/master/payment-modes",
                    });
                  } else {
                    this.$toasted.show(data.message);
                  }
                });
              } else {
                console.log("show error :", data.message);
                this.$toasted.show(Error(data.message));
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/PaymentModesComponents/editPaymentMode.vue